import type { GetCaseTechnicianAssignmentItem } from '@packages/clients';

import type { TechnicianAssignmentEntity } from '../entities';

// Exception: toTechnicianAssignmentEntity is a 1:1 field copy. Normally mappers that perform zero
// transformation should not exist (per domain README, "Mappers" section). This one is kept as an
// intentional DTO-to-entity boundary firewall so that consumers depend on the entity type, not on the
// DTO. If the backend changes field names or types in the future, only this mapper needs updating.

/**
 * Map a backend DTO into a domain-layer {@link TechnicianAssignmentEntity}. Decouples the domain
 * model from the API contract so that changes to the DTO shape do not ripple through consumers.
 *
 * @param dto - the raw assignment item from the backend API
 * @returns a domain entity with the same data
 * @example
 * ```ts
 * const entity = toTechnicianAssignmentEntity(apiItem);
 * console.log(entity.caseTechnicianAssignmentId); // '123'
 * ```
 */
export function toTechnicianAssignmentEntity(dto: GetCaseTechnicianAssignmentItem): TechnicianAssignmentEntity {
    return {
        actualHours: dto.actualHours,
        assignedDate: dto.assignedDate,
        assignmentType: dto.assignmentType,
        caseNumber: dto.caseNumber,
        caseTechnicianAssignmentId: dto.caseTechnicianAssignmentId,
        completedDate: dto.completedDate,
        description: dto.description,
        estimatedHours: dto.estimatedHours,
        isCompleted: dto.completed,
        name: dto.name,
        priority: dto.priority,
        status: dto.status,
        technicianName: dto.technicianName,
    };
}
